module.exports = __webpack_public_path__ + "img/48.276281f0.jpg";